import { NgModule, Type }      from '@angular/core';
import { CommonModule }        from '@angular/common';
import { DynamicButtonsAgent } from '@cs/components/cs-dynamic-button-bar';
import {
	DefaultDashboardPopupDynamicButtonsAgent
}                              from './default-dashboard-popup-dynamic-buttons-agent';

import { DashboardPopupComponent } from './dashboard-popup.component';
import { TranslateModule }         from '@ngx-translate/core';
import { MatDialogModule as MatDialogModule }         from '@angular/material/dialog';
import { MatTooltipModule }        from '@angular/material/tooltip';
import { CsCultureModule }         from '@cs/common';
import { DashboardModule }         from '@cs/components/dashboard';
import { CsSharedModule }          from '@cs/components/shared';


@NgModule({
    declarations: [DashboardPopupComponent],
    imports: [
        CommonModule,
        CsSharedModule,
        DashboardModule,
        MatTooltipModule,
        MatDialogModule,
        TranslateModule.forChild(),
        CsCultureModule
    ]
})
export class DashboardPopupModule {

	static forChild(dynamicPageButtons: Type<DynamicButtonsAgent> = DefaultDashboardPopupDynamicButtonsAgent) {
		return {
			ngModule: DashboardPopupModule, providers: [{
				provide:  DynamicButtonsAgent,
				useClass: dynamicPageButtons
			}]
		};
	}
}
